export const LEARNING_LEVELS = [
  "Kindergarten", "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th",
  "9th", "10th", "11th", "12th", "College", "Graduate", "PhD",
];
export const VOICES = ["alloy", "ash", "coral", "echo", "sage", "shimmer"];
export const LANGUAGES = ["English", "Spanish", "French", "German", "Hindi", "Mandarin"];
export const TEXT_SIZES = ["Small", "Medium", "Large"];
export const HELP_URL = "https://emergent.sh";
export const TABS = [
  { key: "everyday", label: "Everyday", icon: "MessageCircle" },
  { key: "learn", label: "Learn", icon: "BookOpen" },
  { key: "create", label: "Create", icon: "Feather" },
  { key: "research", label: "Research", icon: "Search" },
];
